import React, { useEffect, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import ErrorBoundary from 'components/common/error-boundary';
import { NEW_ROUTE_PREFIX, MOBILE_BREAKPOINT } from 'utils/constants';
import SubHeader from 'components/common/sub-header';
import General from './general';

const AccountEditor = inject(
  'AccountEditor',
  'Notification',
  'Account',
)(
  observer(({ AccountEditor, Notification, match, admin }) => {
    const { save, edit, clearValidation } = AccountEditor;

    const accountId = match.params && match.params.id;
    const isEdit = accountId && accountId !== NEW_ROUTE_PREFIX;
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
      if (isEdit) {
        edit(accountId);
      }
      return () => {
        clearValidation();
      };
    }, []);

    const header = isEdit ? (
      <FormattedMessage id="account.edit" defaultMessage="Edit account" />
    ) : (
      <FormattedMessage id="account.create" defaultMessage="Create account" />
    );

    const submitForm = useCallback(async () => {
      setDisabled(true);
      await save({ admin, isEdit }).catch(e => {
        Notification.showError(e.message);
      });
      setDisabled(false);
    }, [admin, isEdit]);

    const isMobile = window.innerWidth < 1136;
    const width = window.innerWidth;
    const desktop = width >= MOBILE_BREAKPOINT;

    return (
      <form className="ui form">
        <SubHeader
          title={header}
          button={
            <Button
              type="button"
              primary
              disabled={disabled}
              onClick={submitForm}
              style={{ minWidth: isMobile ? 0 : 180 }}
            >
              <FormattedMessage id="buttons.save" />
            </Button>
          }
        />
        <ErrorBoundary>
          <General desktop={desktop} isEdit={isEdit} />
        </ErrorBoundary>
      </form>
    );
  }),
);

export default AccountEditor;
